export const lunrEscapeQuery = (qs) => { // eslint-disable-line
  qs = qs.replace(/\//g, '\\/');
  qs = qs.replace(/-/g, '\\-');
  qs = qs.replace(/:/g, '\\:');
  qs = qs.replace(/#/g, '\\#');
  qs = qs.replace(/\^/g, '\\^');
  qs = qs.replace(/\$/g, '\\$');
  return qs;
};
